<div class="row " style=" margin-top: -20%;">
    <div class="col-md-8 offset-md-2">
        <div class="text-center">
            <h1  class="trainingHeader"><b>Whats New?</b></h1>
            <h5>RegScale is a rapidly growing platform with new features and regular updates.
                Check out our latest blog posts to see what we have been up to lately.</h5>
        </div>

    </div>
</div>

<!-- FOUR Section third -->
<div class="row" style="margin-bottom: 10%;">
    <div class="col-md-4" *ngFor="let p of showPosts">
        <div class="card">
            <img class="img-responsive" style="height: 250px;" [src]="p.image_url" alt="Blog Caption Image">
            <div class="container">
                <h4><b>{{ p.title }}</b></h4>
                <p style="min-height: 80px;">{{ p.description }}</p>
                <div class="container" style="margin-bottom: 25px;">
                    <img [src]="p.author_image" class="rounded-circle" style="max-height: 50px; padding-bottom: 0px; padding-top: 0px;" alt="author image" /> {{ p.author }} <span class="float-right mt-3" style="font-style: italic;"><i class="far fa-calendar" style="color: #F26523"></i> {{ p.datePublished |  date:'fullDate' }}</span>
                </div>
                <div>
                    <a class="btn btn-primary" style="margin-bottom: 25px; color: white;" (click)="navigate(p.route)">Read More</a>
                </div>
            </div>
        </div>
    </div>
</div>
